module.exports = __webpack_public_path__ + "img/disney.172ebd39.jpg";